export default {
    getStaffHeaderFields: state => state.staffHeaderFields,
    getStaffFormActions: state => state.staffFormActions,
    getStaffActions: state => state.staffActions,
    getStaffRowActions: state => state.staffRowActions,
    isStaffFormOpen: state => state.staffFormIsOpen,
    isStaffGridOpen: state => state.staffGridIsOpen,

    getEducationHeaderFields: state => state.educationHeaderFields,
    getEducationFormActions: state => state.educationFormActions,
    getEducationActions: state => state.educationActions,
    getEducationRowActions: state => state.educationRowActions,
    isEducationFormOpen: state => state.educationFormIsOpen,
    isEducationGridOpen: state => state.educationGridIsOpen,

    getCompanyHeaderFields: state => state.companyHeaderFields,
    getCompanyFormActions: state => state.companyFormActions,

    getFeeHeaderFields: state => state.feeHeaderFields,
    getFeeFormActions: state => state.feeFormActions,
    getFeeActions: state => state.feeActions,
    getFeeRowActions: state => state.feeRowActions,
    isFeeFormOpen: state => state.feeFormIsOpen,
    isFeeGridOpen: state => state.feeGridIsOpen,
}
